const style = (theme) => {
  const output = {
    root: {
      padding: '40px 0',
      position: 'relative',
      zIndex: 1,
      color: 'currentColor',
      display: 'flex',
    },
    image: {
      flex: '0 0 420px',
      marginRight: 50,
    },
    additionalData: {},
    info: {
      flex: '1 1 auto',
      color: 'currentColor',
      display: 'flex',
      flexDirection: 'column',
      '& $additionalData': {
        width: '30%',
      },
    },
    spaceBetween: {
      justifyContent: 'space-between',
    },
    flexEnd: {
      alignSelf: 'flex-end',
    },
    role: {
      fontSize: 22,
      fontWeight: 500,
      display: 'block',
      textTransform: 'lowercase',
      '& span': {
        display: 'inline-block',
        '&:before': {
          content: '""',
          position: 'absolute',
          zIndex: -1,
          bottom: 0,
          left: 0,
          width: '100%',
          height: 1,
          background: 'currentColor',
          transformOrigin: '100% 0',
          transition: `transform .5s ${theme.easings['power4.out']}`,
          willChange: 'transform',
        },
      },
    },
    collection: {
      lineHeight: 1.2,
      color: 'currentColor',
      textTransform: 'uppercase',
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 28,
      fontWeight: 500,
    },
    title: {
      lineHeight: 1.2,
      marginRight: 50,
      fontSize: 28,
      fontWeight: 300,
      color: 'currentColor',
      textTransform: 'uppercase',
      display: 'flex',
      justifyContent: 'space-between',
    },
    cta: {
      alignSelf: 'flex-end',
    },
    border: {
      width: '100%',
      flex: '0 0 100%',
      position: 'absolute',
      zIndex: 1,
      height: 1,
      bottom: 0,
      left: 0,
      background: theme.getRgba(theme.colors[1], 0.12),
      transformOrigin: '0 0',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    image: {
      flex: '0 0 200px',
      marginRight: 20,
    },
    title: {
      fontSize: 24,
      marginRight: 0,
    },
    collection: {
      fontSize: 24,
    },
    role: {
      fontSize: 18,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      display: 'block',
    },
    image: {
      display: 'block',
      width: '100%',
      position: 'relative',
      zIndex: 1,
      '& .imageZoom__img': {
        paddingBottom: '100%',
      },
    },
    collection: {
      marginBottom: 20,
      fontSize: 20,
    },
    title: {
      fontSize: 20,
    },
    info: {
      marginTop: 20,
      marginRight: 0,
    },
    role: {
      order: 999,
      '& span': {
        '&:before': {
          content: 'none',
        },
      },
    },
    additionalData: {
      textAlign: 'right',
    },
    cta: {
      display: 'none',
    },
  }

  return output
}

export default style
